/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from '../../../../../../../generated/graphql/types';

export type ProductCardFragment = {
  __typename?: 'ChannelOffer';
  productId: string;
  variantsCount: number;
  sku: {
    __typename?: 'ChannelOfferSku';
    title?: string;
    modelId: string;
    images: Array<{
      __typename?: 'ChannelOfferSkuImage';
      thumbnailUrl?: string;
    }>;
    masterProduct: {
      __typename?: 'ChannelOfferSkuMasterProduct';
      slug: string;
      articleId: string;
      masterCategoryId?: string;
      brand?: {
        __typename?: 'ChannelBrand';
        id: string;
        title: string;
        logo?: string;
      };
    };
  };
  pricing: {
    __typename?: 'OfferPricing';
    sellPrice: {
      __typename?: 'OfferPrice';
      amountVatIncluded: number;
      amountVatExcluded: number;
      currency: Types.Currency;
    };
    retailPrice?: {
      __typename?: 'OfferPrice';
      amountVatIncluded: number;
      currency: Types.Currency;
    };
  };
  commercialAnimation?: {
    __typename?: 'CommercialAnimationAttributes';
    tags: Array<string>;
  };
  coldDeliveryOffers?: {
    __typename?: 'ColdDeliveryOffers';
    hasExpressOffer: boolean;
    isMf: boolean;
    cheapestOffer?: {
      __typename?: 'ColdDeliveryOffer';
      deliveryPrice: { __typename?: 'DeliveryPrice'; amount: number };
    };
  };
  productRating?: {
    __typename?: 'ArticleRatingStats';
    average: number;
    total: number;
  };
};

export const ProductCardFragmentDoc = /*#__PURE__*/ `
    fragment ProductCard on ChannelOffer {
  productId
  variantsCount
  sku {
    title
    modelId
    images {
      thumbnailUrl
    }
    masterProduct {
      slug
      articleId
      masterCategoryId
      brand {
        id
        title
        logo
      }
    }
  }
  pricing {
    sellPrice {
      amountVatIncluded
      amountVatExcluded
      currency
    }
    retailPrice {
      amountVatIncluded
      currency
    }
  }
  commercialAnimation {
    tags
  }
  coldDeliveryOffers {
    hasExpressOffer
    isMf
    cheapestOffer {
      deliveryPrice {
        amount
      }
    }
  }
  productRating {
    average
    total
  }
}
    `;
